module.exports = __webpack_public_path__ + "a3c7fb6c95c7caf7afc856e94d2f3715.png";